import { debugFetch } from '../utils/apiDebug.js';
import { getManagerID, getManagerToken } from '../utils/localStorageManager.js';
import { t } from '../language/pageTranslator.js';
import { initializeTrainingModeRuntime } from '../training/trainingMode.js';

initializeTrainingModeRuntime();

// API calls module for the login functionality

class LoginAPI {
    // Helper method to get auth parameters
    static getAuthParams() {
        const managerID = getManagerID();
        const token = getManagerToken();

        if (!managerID || !token) {
            throw new Error(t('apiError.sessionExpired'));
        }

        return { managerID, token };
    }

    // Manager login
    async managerLogin(email, password) {
        if (!email || !password) {
            throw new Error(t('apiError.missingCredentials'));
        }

        try {
            const params = new URLSearchParams();
            params.append('email', email);
            params.append('password', password);

            const response = await debugFetch('https://hello-zima.appspot.com/MAPIv1/managerLogin', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: params
            });

            if (!response.ok) {
                throw new Error(t('apiError.loginHttpError', { status: response.status }));
            }

            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Login error:', error);
            throw error;
        }
    }

    // Fetch manageable cities
    async manageableCities() {
        try {
            const { managerID, token } = LoginAPI.getAuthParams();
            const params = new URLSearchParams();
            params.append('managerID', managerID);
            params.append('token', token);

            const response = await debugFetch('https://hello-zima.appspot.com/MAPIv1/manageableCities', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: params
            });

            if (!response.ok) {
                throw new Error(t('apiError.fetchCitiesError', { status: response.status }));
            }

            const data = await response.json();
            return data;
        } catch (error) {
            console.error('API fetch error:', error);
            throw error;
        }
    }
}

// Export a single instance of the class
const loginApi = new LoginAPI();
export default loginApi; 
